import { useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';
import { EventPanelFormType, PhoneCallOption } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { useEntityPanelManager } from '../../../panels/entity-panels/monitored-entities/state/entity-panel-manager';
import { useWorkspacePanel } from '../../../panels/hooks/use-workspace-panel';
import { useSendAssociatedPhoneNumberIdToMap } from './use-send-associated-phone-number-id-to-map';

export function useEventPhoneCallMapSync(eventForm: UseFormReturn<EventPanelFormType>) {
    const workspacePanel = useWorkspacePanel<'EVENT'>();
    const entityPanelManager = useEntityPanelManager();
    const eventPanelData = entityPanelManager.getEventPanel(workspacePanel.uuid);
    const sendAssociatedPhoneNumberIdToMap = useSendAssociatedPhoneNumberIdToMap();

    const phoneCall = useWatch({
        control: eventForm.control,
        name: 'phoneCall',
    }) as PhoneCallOption | null;

    const phoneNumberId = phoneCall?.phoneNumberId ?? eventPanelData?.phoneCall?.phoneNumberId;
    const eventPanelsListLength = entityPanelManager.eventPanelsList.length;
    const lastBroadcastRef = useRef<{
        phoneNumberId: number | undefined;
        panelCount: number;
    }>({ phoneNumberId: undefined, panelCount: 0 });

    useEffect(
        function broadcastActivePanelPhoneNumber() {
            if (!workspacePanel.isFocused) {
                return;
            }

            const hasPhoneNumberChanged = lastBroadcastRef.current.phoneNumberId !== phoneNumberId;
            const hasPanelCountChanged =
                lastBroadcastRef.current.panelCount !== eventPanelsListLength;

            if (hasPhoneNumberChanged || hasPanelCountChanged) {
                sendAssociatedPhoneNumberIdToMap(phoneNumberId);
                lastBroadcastRef.current = { phoneNumberId, panelCount: eventPanelsListLength };
            }
        },
        [
            workspacePanel.isFocused,
            phoneNumberId,
            eventPanelsListLength,
            sendAssociatedPhoneNumberIdToMap,
        ]
    );
}
